import { render, staticRenderFns } from "./outgoing-warehousing-history.vue?vue&type=template&id=623bdee2&scoped=true"
import script from "./outgoing-warehousing-history.vue?vue&type=script&lang=ts"
export * from "./outgoing-warehousing-history.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623bdee2",
  null
  
)

export default component.exports